<template>
  <div>
    <h3>
      Fluxos n8n
    </h3>
    <WorkflowList :subjectPermission="subjectPermission"/>
  </div>
</template>
<script lang="ts">
import WorkflowList from './components/WorkflowList.vue';
export default {
  name: 'N8n',
  components: {WorkflowList},
  props: ['subjectPermission'],
};

</script>
